<template>
  <div
      class="employee-grid-profile col-sm-3"
      :style="{
      background: thumbnailBackground,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      position: 'relative'
}"
  >
    <!-- Top bar -->
    <div class="profile-head">
      <div class="dep-name">
        <h5 class="active">
          {{ formattedDate }}
        </h5>
      </div>

      <div class="profile-head-action">
        <div class="dropdown profile-action">
          <a
              href="javascript:void(0);"
              class="action-icon dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false"
          >
            <vue-feather type="more-vertical"></vue-feather>
          </a>

          <ul class="dropdown-menu">
            <li>
              <router-link
                  class="dropdown-item"
                  :to="{
                  name: 'add-edit-podcast',
                  params: { action: 'edit', encodedData: encodedData }
                }"
              >
                <vue-feather type="edit" class="info-img"></vue-feather>
                Edit
              </router-link>
            </li>
            <li>
              <a
                  @click="deletePodcast(podcast)"
                  href="javascript:void(0);"
                  class="dropdown-item confirm-text mb-0"
              >
                <vue-feather type="trash-2" class="info-img"></vue-feather>
                Delete
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Podcast title -->
    <div
        class="profile-info department-profile-info"
        :style="{ cursor: 'pointer' }"
    >
<!--        @click="viewPodcast"-->
      <h4 class="devotion-title">{{ podcast.title }}</h4>
    </div>

    <!-- Bottom info -->
    <ul class="team-members position-absolute" style="bottom: 10px">
      <li>Total Play(s): {{ podcast?.active_listeners ?? 0 }}</li>
    </ul>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {usePodcastStore} from "@/store/podcastStore";
import {encodeUrlData} from "@/views/pages/podcast/utils/data";
import {useRouter} from "vue-router";
import dayjs from "dayjs";

const props = defineProps({
  podcast: {type: Object, required: true},
});

const router = useRouter();
const podcastStore = usePodcastStore();

// === Computed Properties ===
const podcast = computed(() => props.podcast);

const thumbnailBackground = computed(() => {
  const url =
      props.podcast?.thumbnail?.url ||
      "https://images.unsplash.com/photo-1490730141103-6cac27aaab94?q=80";
  return `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('${url}')`;
});

const formattedDate = computed(() =>
    props.podcast?.created_at
        ? dayjs(props.podcast.created_at).format("MMM D, YYYY")
        : ""
);

const encodedData = computed(() => encodeUrlData(props.podcast?.id));

// === Methods ===
async function deletePodcast(podcast) {
  await podcastStore.deletePodcast(podcast.id);
  await podcastStore.fetchPodcasts(); // refresh list after delete
}

function viewPodcast() {
  router.push({
    name: "view-podcast",
    params: {id: props.podcast.id},
  });
}
</script>

<style scoped>
.employee-grid-profile {
  height: 175px;
  border-radius: 15px;
  background-size: cover;
  background-position: center;
  color: white;
  overflow: hidden;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.2s ease-in-out;
}

.employee-grid-profile:hover {
  transform: scale(1.03);
}

.profile-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.devotion-title {
  color: #fff;
  font-weight: 600;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
}
</style>
